/* Phone search results (BNJMN, 4 Nov 2026): tapping "Search" or the x in the path line clears the word and the results; the word's place becomes
   a field with a block caret, and the Suggestions + Featured list (the Search panel's) shows in the room left. Typing shows matching suggestions;
   Enter searches. Phones only (under 750px). */
(function () {
  const root = document.querySelector('.ve-search-results');
  if (!root) return;
  const path = root.querySelector('.ve-search-path');
  const form = path && path.querySelector('.ve-path-edit');
  const input = path && path.querySelector('[data-ve-ps-input]');
  const text = path && path.querySelector('[data-ve-ps-text]');
  const clear = path && path.querySelector('[data-ve-ps-clear]');
  const panel = root.querySelector('[data-ve-ps]');
  if (!form || !input || !text || !clear || !panel) return;
  const live = panel.querySelector('[data-ve-ps-live]');
  const rest = panel.querySelector('[data-ve-ps-rest]');
  const phone = window.matchMedia('(max-width: 749px)');
  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const esc = (t) => t.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const bold = (t, term) => {
    const at = t.toLowerCase().indexOf(term.toLowerCase());
    if (at < 0) return esc(t);
    return esc(t.slice(0, at)) + '<mark>' + esc(t.slice(at, at + term.length)) + '</mark>' + esc(t.slice(at + term.length));
  };
  let token = 0;
  let timer = 0;

  const sync = () => {
    text.textContent = input.value;
    clear.hidden = !input.value;
  };
  const update = async () => {
    const term = input.value.trim();
    sync();
    if (!term) { live.hidden = true; rest.hidden = false; token++; return; }
    const mine = ++token;
    try {
      const response = await fetch(`${base}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=collection,query,product&resources[limit]=10`);
      if (!response.ok) throw new Error(response.status);
      const data = (await response.json()).resources?.results || {};
      if (mine !== token) return;
      const rows = [];
      const seen = new Set();
      const add = (html, label, href) => {
        const key = label.toLowerCase();
        if (seen.has(key)) return;
        seen.add(key);
        rows.push(`<li><a href="${href}">${html}</a></li>`);
      };
      (data.collections || []).forEach((c) => add(bold(c.title, term), c.title, c.url));
      (data.queries || []).forEach((q) => add((q.styled_text || esc(q.text)).replace(/<(?!\/?mark>)[^>]*>/g, ''), q.text, q.url));
      panel.querySelector('[data-ve-ps-results]').innerHTML = rows.slice(0, 6).join('');
      const count = (data.products || []).length;
      const all = panel.querySelector('[data-ve-ps-all]');
      all.href = `${base}search?q=${encodeURIComponent(term)}&options%5Bprefix%5D=last`;
      all.textContent = `${all.dataset.label}${count ? ` (${count >= 10 ? '10+' : count})` : ''}`;
      live.hidden = false;
      rest.hidden = true;
    } catch (error) {
      // suggestions are a convenience: Enter still searches
    }
  };

  const enter = () => {
    if (root.classList.contains('is-editing')) { input.focus({ preventScroll: true }); return; }
    // the Search panel's own list (Suggestions + Featured), copied once
    if (!rest.innerHTML.trim()) {
      const source = document.querySelector('[data-ve-msearch-rest]');
      if (source) rest.innerHTML = source.innerHTML.replace(/ve-msearch__/g, 've-ps__');
    }
    root.classList.add('is-editing');
    form.hidden = false;
    panel.hidden = false;
    input.value = '';
    live.hidden = true;
    rest.hidden = false;
    sync();
    window.scrollTo(0, 0);
    input.focus({ preventScroll: true });
  };
  const leave = () => {
    if (!root.classList.contains('is-editing')) return;
    root.classList.remove('is-editing');
    form.hidden = true;
    panel.hidden = true;
    clear.hidden = true;
    input.blur();
  };

  window.veSearchPath = { enter, leave };
  path.addEventListener('click', (event) => {
    if (!phone.matches) return;
    const hit = event.target.closest('[data-ve-path-search], .ve-picks__clear');
    if (!hit) return;
    event.preventDefault();
    enter();
  });
  input.addEventListener('input', () => { sync(); clearTimeout(timer); timer = setTimeout(update, 150); });
  clear.addEventListener('click', () => { input.value = ''; sync(); update(); input.focus({ preventScroll: true }); });
  form.addEventListener('submit', (event) => { if (!input.value.trim()) event.preventDefault(); });
  document.addEventListener('keyup', (event) => { if (event.code === 'Escape') leave(); });
  phone.addEventListener('change', (event) => { if (!event.matches) leave(); });
})();
